import React, { useEffect, useState } from "react";
import { getHealthState } from "../lib/healthCheck";
import { AlertTriangle, WifiOff, Database } from "lucide-react";

/**
 * Banner discreto in cima all'app quando backend o DB sono giù.
 * Non intrusivo: si nasconde automaticamente al ripristino del servizio.
 */
export default function HealthBanner() {
  const [state, setState] = useState(getHealthState());

  useEffect(() => {
    const handler = (e) => setState(e.detail.next);
    window.addEventListener("ma:health-change", handler);
    return () => window.removeEventListener("ma:health-change", handler);
  }, []);

  if (!state || state.status === "up") return null;

  const label = state.status === "no-db"
    ? "Database temporaneamente non disponibile. Alcune funzioni potrebbero non rispondere."
    : "Server non raggiungibile. Ricontrollo automatico in corso…";

  const Icon = state.status === "no-db" ? Database : WifiOff;

  return (
    <div
      data-testid="health-banner"
      role="alert"
      style={{
        position: "sticky", top: 0, zIndex: 1000,
        background: "var(--ma-warning-bg, #fff8e1)",
        color: "var(--ma-warning-fg, #6b4a00)",
        borderBottom: "1px solid var(--ma-warning-border, #f0d68a)",
        padding: "8px 16px",
        display: "flex", alignItems: "center", gap: 10,
        fontSize: 14,
      }}
    >
      <AlertTriangle size={16} />
      <Icon size={16} />
      <span>{label}</span>
    </div>
  );
}
